import { Hydrate as RqHydrate } from '@tanstack/react-query'

export const Hydrate = RqHydrate
